package pnemonic.balloon_pop.model.tool

import pnemonic.balloon_pop.model.Bonus

class ExtraLife(bonus: Bonus.Life) : BonusTool(bonus)
